import { Controller } from "@hotwired/stimulus"
import QRCode from "qrcode"

// Connects to data-controller="qr-code"
export default class extends Controller {
  static targets = ["canvas", "decreaseSizeButton", "increaseSizeButton"]
  static values = {
    value: String,
    size: { type: Number, default: 200 },
    minSize: { type: Number, default: 100 },
    maxSize: { type: Number, default: 400 },
    sizeStep: { type: Number, default: 50 }
  }

  connect() {
    this.generateQRCode()
  }

  generateQRCode() {
    if (!this.valueValue) return

    QRCode.toCanvas(this.canvasTarget, this.valueValue, {
      width: this.sizeValue,
      margin: 0,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    }).catch(err => {
      console.error('QR Code generation failed:', err)
    })
  }

  increaseSize() {
    if (this.sizeValue < this.maxSizeValue) {
      const oldSize = this.sizeValue
      this.sizeValue += this.sizeStepValue
      this.generateQRCode()
      this.adjustScrollForSizeChange(oldSize, this.sizeValue)
    } else {
      this.increaseSizeButtonTarget.disabled = true
    }
    this.decreaseSizeButtonTarget.disabled = false
  }

  decreaseSize() {
    if (this.sizeValue > this.minSizeValue) {
      this.sizeValue -= this.sizeStepValue
      this.generateQRCode()
    } else {
      this.decreaseSizeButtonTarget.disabled = true
    }
    this.increaseSizeButtonTarget.disabled = false
  }

  adjustScrollForSizeChange(oldSize, newSize) {
    const scrollableContainer = this.findScrollableContainer()
    if (!scrollableContainer) return

    const sizeDifference = newSize - oldSize

    const currentScrollTop = scrollableContainer.scrollTop

    const newScrollTop = currentScrollTop + sizeDifference + 20

    scrollableContainer.scrollTo({
      top: newScrollTop
    })
  }

  findScrollableContainer() {
    let element = this.element.parentElement

    while (element && element !== document.body) {
      const style = window.getComputedStyle(element)
      const overflowY = style.overflowY

      const isElementScrollable = (overflowY === 'scroll' || overflowY === 'auto') && element.scrollHeight > element.clientHeight
      if (isElementScrollable) {
        return element
      }

      element = element.parentElement
    }

    return window
  }

  downloadQRCode() {
    if (!this.valueValue) {
      alert('No value available to generate QR code')
      return
    }

    const link = document.createElement('a')
    link.download = `QR Code ${this.sizeValue}x${this.sizeValue}.png`
    link.href = this.canvasTarget.toDataURL()
    link.click()
  }
}
